<div class="title-container">
    <mat-dialog-content>
        <label class="title">サービス変更</label>
        <div class="selector">
            <!-- select -->
            <form [formGroup]="form">
                <mat-radio-group aria-label="選択して下さい" formControlName="title" class="radio-list">
                    <ng-container *ngFor="let title of titleList; index as i">
                        <mat-radio-button disableRipple [value]="i" [disabled]="disabledId === i">
                            {{ title.name }}
                        </mat-radio-button>
                    </ng-container>

                    <div class="empty"></div>
                </mat-radio-group>
            </form>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-dialog-close mat-button class="cancel">
            {{ cancelTxt }}
        </button>
        <button  mat-button class="excute" (click)="submit()" [disabled]="saveDisabled">
            {{ submitTxt }}
        </button>
    </mat-dialog-actions>

</div>